;(function () {
	const header = () => {
		$('[data-hover-opacity]').hover(
			function () {
				const id = $(this).data('hover-opacity')
				$(`[data-hover-opacity=${id}]`).addClass('opacity')
				$(this).removeClass('opacity')
			},
			function () {
				const id = $(this).data('hover-opacity')
				$(`[data-hover-opacity=${id}]`).removeClass('opacity')
			}
		)

		const megaMenuTabs = () => {
			/**
			 * @param {JQuery} $megaMenu
			 * @param {JQuery} $wrapper
			 */
			const resizeMegaMenuTabArea = ($megaMenu, $wrapper) => {
				const tabs = $megaMenu.find('.mega-menu__tabs')[0]
				const panel = $wrapper.find('[role="tabpanel"]')[0]
				if (!tabs || !panel) return

				if (!tabs.dataset.baseMinHeight) {
					tabs.dataset.baseMinHeight = getComputedStyle(tabs).minHeight
				}

				const baseMinHeight =
					Number.parseFloat(tabs.dataset.baseMinHeight) || 0
				tabs.style.minHeight = `${baseMinHeight}px`
				tabs.style.minHeight = `${Math.max(baseMinHeight, panel.scrollHeight)}px`
			}

			/** @param {HTMLElement} wrapper */
			const activateMegaMenuTab = function (wrapper) {
				const $wrapper = $(wrapper)
				const $megaMenu = $wrapper.closest('.mega-menu--tabs')
				const $wrappers = $megaMenu.find('.mega-menu__tab-wrapper')

				$wrappers.removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$wrappers.find('[role="tab"]').attr('aria-selected', 'false')
				$wrappers
					.find('[role="tabpanel"]')
					.attr('aria-hidden', 'true')
					.attr('inert', '')
				$wrapper.addClass('mega-menu__tab-wrapper--active')
				$wrapper.find('[role="tab"]').attr('aria-selected', 'true')
				$wrapper
					.find('[role="tabpanel"]')
					.attr('aria-hidden', 'false')
					.removeAttr('inert')

				const tabIndex = $wrapper.data('tab-index')
				const $images = $wrapper
					.closest('.mega-menu--tabs')
					.find('.mega-menu__tab-image')
				if ($images.length) {
					$images.removeClass('mega-menu__tab-image--active')
					$images
						.filter(`[data-tab-index="${tabIndex}"]`)
						.addClass('mega-menu__tab-image--active')
				}

				resizeMegaMenuTabArea($megaMenu, $wrapper)
			}

			$('.mega-menu__tab-wrapper').mouseenter(function (event) {
				activateMegaMenuTab(this)
			})
			$('.mega-menu__tab-wrapper').focus(function (event) {
				activateMegaMenuTab(this)
			})
			$('.mega-menu__tab-wrapper').focusin(function (event) {
				activateMegaMenuTab(this)
			})
			$('.mega-menu__tab-heading').click(function () {
				const wrapper = $(this).closest('.mega-menu__tab-wrapper')[0]
				if (wrapper) activateMegaMenuTab(wrapper)
			})
			$('.mega-menu--tabs').each(function () {
				const wrapper = $(this).find(
					'.mega-menu__tab-wrapper--active'
				)[0]
				if (wrapper) activateMegaMenuTab(wrapper)
			})
		}
		megaMenuTabs()

		const headerElement = document.querySelector('.header-main-section')

		if (
			headerElement &&
			headerElement.classList.contains('color-background-overlay')
		) {
			headerElement.addEventListener('mouseenter', () => {
				headerElement.classList.remove('color-background-overlay')
				headerElement.classList.remove('color-background-4')
			})
			headerElement.addEventListener('mouseleave', () => {
				headerElement.classList.add('color-background-overlay')
				if (headerElement.classList.contains('overlay-effect')) {
					headerElement.classList.add('color-background-1')
				} else {
					headerElement.classList.add('color-background-4')
				}
			})
		}
	}

	/** @param {EventTarget | null} target */
	const openMegaMenuInEditor = (target) => {
		document
			.querySelectorAll('.header__list li.mega-menu--force-open')
			.forEach((item) => item.classList.remove('mega-menu--force-open'))

		const megaMenu =
			target instanceof Element && target.classList.contains('header-mega-menu')
				? target
				: target instanceof Element
					? target.closest('.header-mega-menu')
					: null

		megaMenu?.closest('li')?.classList.add('mega-menu--force-open')
	}

	/** @param {EventTarget | null} target */
	const closeMegaMenuInEditor = (target) => {
		const megaMenu =
			target instanceof Element && target.classList.contains('header-mega-menu')
				? target
				: target instanceof Element
					? target.closest('.header-mega-menu')
					: null

		megaMenu?.closest('li')?.classList.remove('mega-menu--force-open')
	}

	document.addEventListener('shopify:block:select', (event) => {
		openMegaMenuInEditor(event.target)
	})

	document.addEventListener('shopify:block:deselect', (event) => {
		closeMegaMenuInEditor(event.target)
	})

	document.addEventListener('shopify:section:load', header)
	header()
})()
